import { requireEnv } from '@/lib/env'

/**
 * Public URL for an Nhost storage file.
 *
 * Extracted because this was independently duplicated in booking-context.ts and
 * booking.ts, and a third copy was about to appear. The base URL fails loud when
 * unset rather than falling back to a hardcoded host - a missing env here would
 * otherwise surface as silently broken images across the booking site.
 */
const NHOST_STORAGE_URL = requireEnv(
  process.env.NEXT_PUBLIC_NHOST_STORAGE_URL,
  'NEXT_PUBLIC_NHOST_STORAGE_URL'
).replace(/\/$/, '')

export function getStorageUrl(fileId: string | null | undefined): string | null {
  if (!fileId) return null
  return `${NHOST_STORAGE_URL}/files/${fileId}`
}
